import { Col, Row } from "react-bootstrap"

import FormatPhone from "../../../formatters/FormatPhone"

interface NotificationApplicationUserInfoProps {
  UserName: string
  FirstName: string
  LastName: string
  Email: string
  Phone: string
}

function NotificationApplicationUserInfo({
  UserName,
  FirstName,
  LastName,
  Email,
  Phone,
}: NotificationApplicationUserInfoProps) {
  const INFO_FIELDS = [
    { label: "User Name", value: UserName },
    { label: "Name", value: `${FirstName} ${LastName}` },
    { label: "Email", value: Email },
    { label: "Phone Number", value: FormatPhone(Phone) },
  ]

  return (
    <>
      {INFO_FIELDS.map((field) => (
        <Row key={field.label.replace(/\s+/g, "_")}>
          <Col sm={3} className="py-2">
            {field.label}
          </Col>
          <Col>
            <div className="py-2 pl-1 border-bottom">{field.value}</div>
          </Col>
        </Row>
      ))}
    </>
  )
}

export default NotificationApplicationUserInfo
